const collection = {
  "Secure NFT": "NFT Sécurisés, par KeeeX",
  "Create, Collect, Exchange": "Créez, Collectionnez, Transférez",
  "New collections": "Dernières collections",
  "New artworks": "Dernières œuvres d'art",
  "Create your NFT": "Créez votre NFT",
};

export default collection;
